import React from "react";

const variants = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost: "btn-ghost",
  danger: "inline-flex items-center justify-center gap-2 rounded-full border border-red-400/40 bg-red-500/10 px-5 py-2.5 text-sm font-semibold text-red-100 transition hover:bg-red-500/20",
};

function Button({ asChild = false, variant = "primary", className = "", ...props }) {
  const Comp = asChild ? "span" : "button";
  const base = variants[variant] || variants.primary;
  return <Comp className={`${base} ${className}`} {...props} />;
}

export default Button;
